import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AuditRunResultFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.AUDIT_RUN_RESULT}
        filterName={FilterName.AUDIT_RUN_RESULT}
        valueKey="auditRunResults"
        isNested={isNested}
      />
    )
  },
)
